import { useCallback, useEffect, useState } from 'react';
import axios from 'axios';
import { toast } from 'sonner';
import { RefreshCw } from 'lucide-react';
import { formatDateTimeBR } from '../lib/dateFormat';

const API_URL = process.env.REACT_APP_BACKEND_URL;

export function EspelhoTipStatus({ onAtualizado }) {
  const [st, setSt] = useState(null);
  const [rodando, setRodando] = useState(false);
  const [aberto, setAberto] = useState(false);

  const carregar = useCallback(() => axios.get(`${API_URL}/api/operadora/espelho-tip`, { withCredentials: true })
    .then(r => setSt(r.data)).catch(() => {}), []);
  useEffect(() => { carregar(); const t = setInterval(carregar, 60000); return () => clearInterval(t); }, [carregar]);

  const conferir = async () => {
    setRodando(true);
    try {
      const r = await axios.post(`${API_URL}/api/operadora/espelho-tip/executar`, {}, { withCredentials: true });
      toast.success(r.data.mudancas ? `${r.data.mudancas} ICCID(s) atualizados pela Tip` : 'Tudo igual à Tip');
      await carregar();
      onAtualizado?.();
    } catch (e) {
      toast.error(e.response?.data?.detail || 'Erro ao conferir com a Tip');
    } finally {
      setRodando(false);
    }
  };

  const mudancas = st?.ultimas_mudancas || [];
  return (
    <div className="relative mt-1 text-xs text-zinc-400" data-testid="espelho-tip-status">
      <span>Situação de cada ICCID espelhada da Tip a cada 15 min</span>
      {st?.ultima_execucao && <span data-testid="espelho-tip-ultima"> · conferido em {formatDateTimeBR(st.ultima_execucao)}</span>}
      {st?.erro && <span className="text-amber-300" data-testid="espelho-tip-erro"> · última tentativa falhou: {st.erro}</span>}
      <button type="button" onClick={conferir} disabled={rodando} className="ml-2 inline-flex items-center gap-1 text-blue-400 hover:text-blue-300 disabled:opacity-50" data-testid="espelho-tip-conferir">
        <RefreshCw className={`w-3 h-3 ${rodando ? 'animate-spin' : ''}`} /> {rodando ? 'Conferindo...' : 'Conferir agora'}
      </button>
      {mudancas.length > 0 && (
        <button type="button" onClick={() => setAberto(a => !a)} className="ml-3 text-zinc-300 underline" data-testid="espelho-tip-ver-mudancas">
          {aberto ? 'esconder' : 'ver'} últimas mudanças ({mudancas.length})
        </button>
      )}
      {aberto && (
        <ul className="absolute left-0 top-full z-30 mt-2 w-[44rem] max-w-[90vw] max-h-64 overflow-auto space-y-0.5 rounded-sm border border-zinc-700 bg-zinc-900 p-3 text-zinc-300 shadow-xl" data-testid="espelho-tip-mudancas">
          {mudancas.map((m, i) => (
            <li key={`${m.iccid}-${m.em}-${i}`}>
              {formatDateTimeBR(m.em)} · <b>{m.cliente || 'Sem nome'}</b> · <span className="font-mono">{m.iccid}</span>:
              {m.de !== m.para && <> {m.de} → <span className={m.para === 'bloqueado' ? 'text-red-400' : m.para === 'ativo' ? 'text-emerald-400' : 'text-zinc-400'}>{m.para}</span></>}
              {m.numero_antigo !== null && m.numero_antigo !== undefined && <> número {m.numero_antigo || '-'} → {m.numero}</>}
              <span className="text-zinc-500"> (Tip: {m.status_tip})</span>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
